import React, { useEffect, useState, useRef } from 'react';
import { ComponentLoader } from '../common/Loader';
import { useDispatch } from 'react-redux';
import {
    PieChart,
    Pie,
    Cell,
    Tooltip,
    ResponsiveContainer,
} from "recharts";
import { fetchGenderDistribution, fetchUsersLocation } from "./store";

const GenderDistribution = ({ locations = [] }) => {
    const dispatch = useDispatch();
    const [genderData, setGenderData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [locationsLocal, setLocationsLocal] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState('');
    const dataFetchedRef = useRef(false);

    // Fetch User Locations and Gender Distribution on mount
    // useEffect(() => {
    //     if (dataFetchedRef.current) return;

    //     const cacheKey = 'GENDER_DISTRIBUTION_CACHE';
    //     const cachedData = sessionStorage.getItem(cacheKey);
    //     if (cachedData) {
    //         const data = JSON.parse(cachedData);
    //         if (data === 'PENDING') return;

    //         const cacheTimestamp = data.cacheTimestamp || 0;
    //         const threeMinutes = 3 * 60 * 1000;
    //         const isExpired = Date.now() - cacheTimestamp > threeMinutes;
    //         if (!isExpired) {
    //             console.log("%cGender Distribution Status: 304 (From Session Cache)", "color: #0ea5e9; font-weight: bold;");
    //             setGenderData(data.genderData);
    //             setLocationsLocal(data.locationsLocal);
    //             setSelectedLocation(data.selectedLocation);
    //             setLoading(false);
    //             dataFetchedRef.current = true;
    //             return;
    //         } else {
    //             console.log("%cGender Distribution Status: Cache Expired (3 mins limit)", "color: #f59e0b; font-weight: bold;");
    //             sessionStorage.removeItem(cacheKey);
    //         }
    //     }

    //     // Mark as pending
    //     sessionStorage.setItem(cacheKey, JSON.stringify('PENDING'));

    //     setLoading(true);
    //     // Fetch Gender Distribution (initial load)
    //     dispatch(fetchGenderDistribution(''))
    //         .then((response) => {
    //             if (response.payload && response.payload.success) {
    //                 const { Male, Female, Other } = response.payload.data;
    //                 const gData = [
    //                     { name: 'Female', value: Female, color: '#EC4899' },
    //                     { name: 'Male', value: Male, color: '#3B82F6' },
    //                     { name: 'Other', value: Other, color: '#9CA3AF' },
    //                 ];
    //                 setGenderData(gData);
    //                 sessionStorage.setItem('GENDER_DISTRIBUTION_CACHE', JSON.stringify({
    //                     genderData: gData,
    //                     locationsLocal: [],
    //                     selectedLocation: '',
    //                     cacheTimestamp: Date.now()
    //                 }));
    //                 console.log("%cGender Distribution Status: 200 (Fresh Fetch)", "color: #10b981; font-weight: bold;");
    //             }
    //             setLoading(false);
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching gender distribution:', error);
    //             setLoading(false);
    //         });
    // }, [dispatch]);

    useEffect(() => {
        if (dataFetchedRef.current) return;

        const cacheKey = 'GENDER_DISTRIBUTION_CACHE';
        const CACHE_DURATION = 3 * 60 * 1000;

        let cacheExists = false;

        const cachedData = sessionStorage.getItem(cacheKey);

        if (cachedData) {
            const data = JSON.parse(cachedData);

            // Prevent duplicate API calls
            if (data === 'PENDING') {

                return;
            }

            if (data && typeof data === 'object') {
                const cacheTimestamp = data.cacheTimestamp || 0;
                const isExpired = Date.now() - cacheTimestamp > CACHE_DURATION;

                // Valid Cache
                if (!isExpired) {

                    setGenderData(data.genderData);
                    setLocationsLocal(data.locationsLocal);
                    setSelectedLocation(data.selectedLocation);

                    setLoading(false);

                    dataFetchedRef.current = true;

                    return;
                }

                // Expired Cache → Show stale data while refreshing


                setGenderData(data.genderData);
                setLocationsLocal(data.locationsLocal);
                setSelectedLocation(data.selectedLocation);

                setLoading(false);

                cacheExists = true;
            }
        }


        // Mark request as pending
        sessionStorage.setItem(cacheKey, JSON.stringify('PENDING'));

        dataFetchedRef.current = true;

        setLoading(true);

        // Fetch API
        dispatch(fetchGenderDistribution(''))
            .then((response) => {

                if (response.payload && response.payload.success) {

                    const { Male, Female, Other } = response.payload.data;

                    const gData = [
                        { name: 'Female', value: Female || 0, color: '#EC4899' },
                        { name: 'Male', value: Male || 0, color: '#3B82F6' },
                        { name: 'Other', value: Other || 0, color: '#9CA3AF' },
                    ];

                    setGenderData(gData);

                    const updatedCache = {
                        genderData: gData,
                        locationsLocal: [],
                        selectedLocation: '',
                        cacheTimestamp: Date.now()
                    };

                    // Update cache
                    sessionStorage.setItem(
                        cacheKey,
                        JSON.stringify(updatedCache)
                    );

                } else {

                    // Remove pending only if no stale cache exists
                    if (!cacheExists) {
                        sessionStorage.removeItem(cacheKey);
                    }
                }

                setLoading(false);
            })
            .catch((error) => {

                console.error('Error fetching gender distribution:', error);

                // Important Fix:
                // Remove PENDING only if no stale cache exists
                if (!cacheExists) {
                    sessionStorage.removeItem(cacheKey);
                }

                setLoading(false);
            });

    }, [dispatch]);


    // Handle location change
    // const handleLocationChange = (e) => {
    //     const location = e.target.value;
    //     setSelectedLocation(location);
    //     setLoading(true);

    //     dispatch(fetchGenderDistribution(location))
    //         .then((response) => {
    //             if (response.payload && response.payload.success) {
    //                 const { Male, Female, Other } = response.payload.data;
    //                 setGenderData([
    //                     { name: 'Female', value: Female, color: '#EC4899' },
    //                     { name: 'Male', value: Male, color: '#3B82F6' },
    //                     { name: 'Other', value: Other, color: '#9CA3AF' },
    //                 ]);
    //             }
    //             setLoading(false);
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching gender distribution:', error);
    //             setLoading(false);
    //         });
    // };

    return (
        <div style={{
            background: '#fff',
            borderRadius: '12px',
            padding: '24px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            flex: '1',
            minWidth: '300px',
            height: '450px'
        }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ width: '4px', height: '20px', background: '#3b82f6', borderRadius: '2px' }}></div>
                    <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: '#333' }}>Gender Distribution</h3>
                </div>
                {/* <select
                    value={selectedLocation}
                    onChange={handleLocationChange}
                    style={{
                        padding: '8px 12px',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        fontSize: '13px',
                        color: '#374151',
                        background: '#f9fafb',
                        cursor: 'pointer',
                        minWidth: '150px'
                    }}
                >
                    <option value="">All Locations</option>
                    {locations.map((loc, index) => (
                        <option key={index} value={loc.city}>{loc.city}</option>
                    ))}
                </select> */}
            </div>
            {loading ? (
                <div style={{ height: '280px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <ComponentLoader color="#3b82f6" size="40px" />
                </div>
            ) : (
                <ResponsiveContainer width="100%" height={280}>
                    <PieChart>
                        <Pie
                            data={genderData}
                            cx="50%"
                            cy="50%"
                            innerRadius={60}
                            outerRadius={100}
                            paddingAngle={2}
                            dataKey="value"
                        >
                            {genderData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={entry.color} />
                            ))}
                        </Pie>
                        <Tooltip />
                    </PieChart>
                </ResponsiveContainer>
            )}
            <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginTop: '8px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <div style={{ width: '10px', height: '10px', background: '#EC4899', borderRadius: '2px' }}></div>
                    <span style={{ fontSize: '11px' }}>Female</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <div style={{ width: '10px', height: '10px', background: '#3B82F6', borderRadius: '2px' }}></div>
                    <span style={{ fontSize: '11px' }}>Male</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <div style={{ width: '10px', height: '10px', background: '#9CA3AF', borderRadius: '2px' }}></div>
                    <span style={{ fontSize: '11px' }}>Other</span>
                </div>
            </div>
        </div>
    );
};

export default GenderDistribution;
